
export const outline = [{
    title: 'Bore',
    dataIndex: 'jobNumber',
    sortOrder: 'ascend', //dosnt work
    key: 'bore',
    width: 65,
  }, {
    title: 'Title',
    dataIndex: 'record.form_values["94d5"]',
    key: 'title',
    width: 180,
  }, {
    title: 'Location',
    dataIndex: 'record.form_values["94d5"]',
    key: 'location',
    width: 180,
    className: 'hideThis'
  }, {
    title: 'Driller',
    dataIndex: 'record.form_values[3493].choice_values["0"]',
    key: 'driller',
    width: 100,
  }, {
    title: 'Status',
    dataIndex: 'record.status',
    key: 'status',
    width: 100,
  }, {
    title: 'Start',
    dataIndex: 'record.form_values.c769',
    key: 'start',
    width: 80,
    className: 'hideThis',
    render: start => {
      if (start) {
        var str = start.split("-");
        var fYear = str[0],
            fMonth = str[1],
            fDay = str[2];

        return fDay + "-" + fMonth + "-" + fYear;
      }
      return
    }
}]

export const completed = [{
  title: 'Completed',
  colSpan: 2,
  dataIndex: 'bore',
  sortOrder: 'ascend',
  key: 'bore',
  width: 50,
  className: 'outlineCompleted'
},{
  title: 'Completed',
  colSpan: 0,
  width: 100,
  dataIndex: 'client',
}]

export const inProgress = [{
  title: 'In Progress',
  colSpan: 2,
  dataIndex: 'bore',
  sortOrder: 'ascend',
  key: 'bore',
  width: 50,
  className: 'outlineInProgress'
},{
  title: 'In Progress',
  colSpan: 0,
  width: 100,
  dataIndex: 'client',
}]

export const upcoming = [{
  title: 'Upcoming',
  colSpan: 2,
  dataIndex: 'bore',
  sortOrder: 'ascend',
  key: 'bore',
  width: 50,
  className: 'outlineUpcoming'
},{
  title: 'Upcoming',
  colSpan: 0,
  width: 100,
  dataIndex: 'client',
}]

export const awaitingPayment = [{
  title: 'Awaiting Payment',
  colSpan: 2,
  dataIndex: 'bore',
  sortOrder: 'ascend',
  key: 'bore',
  width: 50,
  className: 'outlineAwaitingPayment'
},{
  title: 'AwaitingPayment',
  colSpan: 0,
  width: 100,
  dataIndex: 'client',
}]
